import { METHOD } from 'services/method'

export const API_MANIFEST = {
    SHIPPING_METHODS: {
        api: '/v1/master/shipping-methods',
        method: METHOD.GET,
    },
    PACKING_LIST: {
        api: '/v1/dashboard-admin/manifest/packing/list',
        method: METHOD.POST,
    },
    LIST: {
        api: '/v1/dashboard-admin/manifest/list',
        method: METHOD.POST,
    },
    WITHOUT_AWB: {
        api: '/v1/dashboard-admin/manifest/no-awb/list',
        method: METHOD.POST,
    },
    BULK_MANIFEST: {
        api: '/v1/dashboard-admin/manifest/scan',
        method: METHOD.POST,
    },
    BULK_PRINT_MANIFEST: {
        api: '/v1/dashboard-admin/manifest/move',
        method: METHOD.POST,
    },
    ADD_MANUAL_AWB: {
        api: '/v1/dashboard-admin/manifest/input-awb',
        method: METHOD.POST,
    },
}
